module.exports = __webpack_public_path__ + "img/delete.6005847c.svg";